import { get } from 'lodash';
import { paddingToString } from './css-utils';
export var getRegionSpacing = function (css, type, fallbackClass) {
    if (fallbackClass === void 0) { fallbackClass = undefined; }
    var globalRegion = css['so-global-region'];
    var region = css[fallbackClass || "so-global-region-" + type] || {};
    var margin = {
        top: parseInt(region.marginTop || globalRegion.marginTop, 10) || 0,
        right: parseInt(region.marginRight || globalRegion.marginRight, 10) || 0,
        bottom: parseInt(region.marginBottom || globalRegion.marginBottom, 10) || 0,
        left: parseInt(region.marginLeft || globalRegion.marginLeft, 10) || 0,
    };
    var padding = {
        top: parseInt(region.paddingTop || globalRegion.paddingTop, 10) || 0,
        right: parseInt(region.paddingRight || globalRegion.paddingRight, 10) || 0,
        bottom: parseInt(region.paddingBottom || globalRegion.paddingBottom, 10) || 0,
        left: parseInt(region.paddingLeft || globalRegion.paddingLeft, 10) || 0,
    };
    return {
        padding: padding,
        margin: margin,
    };
};
export var getSectionPadding = function (css, type) {
    return paddingToString(getSectionPaddingAsObject(css, type));
};
export var getSectionPaddingAsObject = function (css, type, userOverrides) {
    if (userOverrides === void 0) { userOverrides = undefined; }
    var globalRegion = css['so-global-region'];
    var region = css["so-global-region-" + type] || {};
    var bodyPaddingLeft = parseInt(get(css, 'so-global-body.paddingLeft'), 10) || 0;
    var bodyPaddingRight = parseInt(get(css, 'so-global-body.paddingRight'), 10) || 0;
    var padding = {
        top: parseInt((userOverrides === null || userOverrides === void 0 ? void 0 : userOverrides.paddingTop) ||
            region.paddingTop ||
            globalRegion.paddingTop, 10) || 0,
        right: parseInt((userOverrides === null || userOverrides === void 0 ? void 0 : userOverrides.paddingRight) ||
            region.paddingRight ||
            globalRegion.paddingRight, 10) || 0,
        bottom: parseInt((userOverrides === null || userOverrides === void 0 ? void 0 : userOverrides.paddingBottom) ||
            region.paddingBottom ||
            globalRegion.paddingBottom, 10) || 0,
        left: parseInt((userOverrides === null || userOverrides === void 0 ? void 0 : userOverrides.paddingLeft) ||
            region.paddingLeft ||
            globalRegion.paddingLeft, 10) || 0,
    };
    padding.left += bodyPaddingLeft;
    padding.right += bodyPaddingRight;
    return padding;
};
export var getSectionMarginAsObject = function (css, type) {
    var globalRegion = css['so-global-region'];
    var region = css["so-global-region-" + type] || {};
    return {
        top: parseInt(region.marginTop || globalRegion.marginTop, 10) || 0,
        right: parseInt(region.marginRight || globalRegion.marginRight, 10) || 0,
        bottom: parseInt(region.marginBottom || globalRegion.marginBottom, 10) || 0,
        left: parseInt(region.marginLeft || globalRegion.marginLeft, 10) || 0,
    };
};
//# sourceMappingURL=get-section-padding.js.map